import { Injectable } from '@angular/core';
import {
  ExportSearchGQL,
  FiltersGQL,
  SearchGQL,
  SearchSuggestGQL,
} from '@epicuro-next/data/product';
import {
  Product,
  SearchFilterQuery,
  SearchQuery,
} from 'graphql-api/gql-api-interfaces';
import { map, take } from 'rxjs/operators';

/**
 * Service to fetch product basket data
 */
@Injectable()
export class ProductBasketService {
  constructor(
    private searchGql: SearchGQL,
    private searchSuggestGql: SearchSuggestGQL,
    private filtersGql: FiltersGQL,
    private exportSearch: ExportSearchGQL,
  ) {}

  public getProducts(query: SearchQuery, cacheFirst = true) {
    return this.searchGql
      .fetch(
        {
          query,
        },
        cacheFirst ? { fetchPolicy: 'cache-first' } : undefined,
      )
      .pipe(
        take(1),
        map((queryResult) => ({
          products: (queryResult.data.search?.products as Product[]) ?? [],
          resultCount: queryResult.data.search?.totalResultCount ?? 0,
        })),
      );
  }

  public getSuggestProducts(query: SearchQuery, cacheFirst = true) {
    return this.searchSuggestGql
      .fetch(
        {
          query,
        },
        cacheFirst ? { fetchPolicy: 'cache-first' } : undefined,
      )
      .pipe(
        take(1),
        map((queryResult) => ({
          products: queryResult.data.searchSuggest?.products ?? [],
          totalResultCount:
            queryResult.data.searchSuggest?.totalResultCount ?? 0,
          suggestions: queryResult.data.searchSuggest?.suggestions ?? [],
        })),
      );
  }

  /**
   * Fetches the filters from GQL
   */
  public getFilters(query: SearchFilterQuery) {
    return this.filtersGql
      .fetch(
        {
          query,
        },
        { fetchPolicy: 'no-cache' },
      )
      .pipe(
        take(1),
        map((queryResult) => queryResult.data.searchOptions),
      );
  }

  public exportProducts(query: SearchQuery) {
    return this.exportSearch
      .fetch({
        query,
      })
      .pipe(
        take(1),
        map((result) => result.data.exportSearch),
      );
  }
}
